import { render, staticRenderFns } from "./ApprovalForms.vue?vue&type=template&id=744ff71c"
import script from "./ApprovalForms.vue?vue&type=script&lang=js"
export * from "./ApprovalForms.vue?vue&type=script&lang=js"
import style0 from "./ApprovalForms.vue?vue&type=style&index=0&id=744ff71c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports